/**
 * Escolha de cor de lista e de tag.
 *
 * Componente proprio, e nao um `<input type="color">` solto em cada painel,
 * pela mesma razao de `lib/grouping.ts`: listas e tags precisam da MESMA nocao
 * de "escolher cor", e duas copias divergiriam na primeira vez que alguem
 * mexesse no alvo de toque ou no rotulo acessivel.
 *
 * **Cor livre, e nao uma paleta fechada.** A cor nunca vira fundo de texto em
 * lugar nenhum do app — ela e o pontinho ao lado do nome e a faixa do card —,
 * entao nao ha razao de contraste (spec 10.5) para limitar a escolha. Onde a
 * cor tocaria texto, a decisao ja foi tomada ao contrario: o chip da tag usa
 * fundo neutro justamente porque cor escolhida livremente nao passa por
 * checagem de contraste.
 *
 * O `<input type="color">` nativo carrega de graca o seletor do sistema
 * operacional, o suporte a teclado e o rotulo acessivel — uma grade de
 * quadradinhos escrita a mao teria de reimplementar os tres.
 *
 * **Cuidado ao montar este campo num formulario:** ele e o SEGUNDO campo, e um
 * formulario com dois campos e nenhum botao de submit perde a submissao
 * implicita por Enter (regra do HTML, nao do React). Todo formulario que usa
 * este componente precisa de um botao `type="submit"` visivel — que e, de
 * qualquer forma, o unico jeito de salvar por toque.
 */
export function ColorField({
  id,
  label,
  value,
  onChange,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (color: string) => void;
}) {
  return (
    <>
      <label className="sr-only" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        type="color"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        // `min-h-touch` no proprio input: o alvo de 44px da spec 10.5 vale para
        // o controle, e nao para o rotulo — que aqui e invisivel.
        className="min-h-touch w-10 shrink-0 cursor-pointer rounded-sm border border-border bg-surface p-1"
      />
    </>
  );
}
